import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Grid,
  Step,
  StepContent,
  StepIcon,
  Stepper,
  Typography
} from '@mui/material';

import { CaseDetailsBox } from '@/components/CaseDetailsBox';
import type { InvestigationCycle as InvestigationCycleType } from '@/pages/Case/Case.types';
import { CaseIdLink } from '@/pages/Case/CaseIdLink';

export const InvestigationCycle = ({
  cycle,
  index
}: {
  cycle: InvestigationCycleType;
  index: number;
}) => (
  <>
    <Typography
      variant="h5"
      component="h5"
      gutterBottom
      style={{ marginTop: index === 0 ? '1rem' : '2rem' }}
    >
      Investigation Cycle {cycle.id}
    </Typography>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 4 }}>
        <Typography sx={{ fontWeight: 'bold' }}>Conclusion</Typography>
        <Typography sx={{ pb: 4 }}>
          <CaseIdLink>{cycle.reasoning}</CaseIdLink>
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, lg: 8 }} sx={{ pt: { xs: 0, lg: 2 } }}>
        <Stepper orientation="vertical">
          {cycle.batchData.map((batch) => (
            <Step key={batch.batchId} expanded>
              <StepIcon
                icon={
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    size="xl"
                    color="var(--mui-palette-text-secondary)"
                    style={{ marginLeft: '0.25rem', marginTop: '12px' }}
                  />
                }
              />
              <StepContent>
                <Box sx={{ mt: -4.5 }}>
                  <CaseDetailsBox
                    key={`${batch.batchId}`}
                    id={batch.batchId}
                    labels={batch.batchLabel ? [batch.batchLabel] : []}
                    lowerText={batch.batchReasoning}
                    upperText={batch.batchConclusion}
                  />
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Grid>
    </Grid>
  </>
);

export default InvestigationCycle;
